import { EnumGrupoDocumento } from '../../../../api'
import { DocumentModel } from '../../../../api/Argentia/endpoints/documents/model/document'
import { FilesLoadingResponse } from '../../../../api/Pioneer/model/Files'
import { enumKeyToValue } from '../../../../helpers'
import {
  formatDateOnlyDate,
  formatDateOnlyStringWithTime
} from '../../../../helpers/formatDateOnly'
import {
  FileModel,
  FileQueued,
  UploadedFileResume,
  UploadedFileStates
} from './comunicationFiles.model'
import {
  getGlobalActionsConfiguration,
  getGlobalObjectionsActionsConfiguration
} from './comunicationFiles.service'

export const comunicationsFilesListItemsMapper = (items: DocumentModel[]): FileModel[] => {
  return items && items.map(comunicationsFilesItemMapper)
}

export const comunicationsFilesItemMapper = (item: DocumentModel): FileModel => {
  return (
    item && {
      id: item.id,
      dischargedDate: formatDateOnlyStringWithTime(item.modificationDate ?? item.creationDate),
      documentType: item.type,
      description: item.description,
      documentDate: formatDateOnlyDate(item.documentDate),
      endDate: formatDateOnlyDate(item.documentEndDate),
      state: item.state,
      documentGroup: enumKeyToValue(EnumGrupoDocumento, item.documentGroup),
      url: item.url,
      urlLog: item.urlLog,
      actionsConfiguration: getGlobalActionsConfiguration(),
      objectionsActionsConfiguration: getGlobalObjectionsActionsConfiguration(),
      isFileOk: item.urlLog === null,
      isErrorLog: item.urlLog !== null && item.urlLog !== ''
    }
  )
}

export const communicationFileLoadingItemsMapper = (
  items: FilesLoadingResponse[]
): FileQueued[] => {
  return items && items.map(communicationFileLoadingItemMapper)
}

export const communicationFileLoadingItemMapper = (item: FilesLoadingResponse): FileQueued => {
  return (
    item && {
      fileName: item.fileName,
      queued: item.statusCode === 200 || item.statusCode === 'OK'
    }
  )
}

export const communicationUploadFileResultItemsMapper = (
  items: FilesLoadingResponse[]
): UploadedFileResume[] => {
  return items && items.map(communicationUploadFileResultItemMapper)
}

export const communicationUploadFileResultItemMapper = (
  item: FilesLoadingResponse
): UploadedFileResume => {
  return (
    item && {
      fileName: item.fileName,
      state:
        item.statusCode === 201 || item.statusCode === 200 || item.statusCode === 'OK'
          ? UploadedFileStates.QUEUED
          : UploadedFileStates.ERROR
    }
  )
}
